import { render, staticRenderFns } from "./DataAssets.vue?vue&type=template&id=8ba9b690"
import script from "./DataAssets.vue?vue&type=script&lang=js"
export * from "./DataAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports